import React from "react";
import Pro from "../../assets/images/pro.png";
import location from "../../assets/images/location.png";
import Call from "../../assets/images/call.png";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
const HospitalCard = ({ data }) => {
  // console.log("data", data);
  const navigate = useNavigate();
  return (
    <div className="border-[1px] border-zinc-400 p-4 rounded-md overflow-hidden mb-5">
      <div
        className="flex gap-[10px] items-center cursor-pointer"
        onClick={() => {
          // onSelect(data?.latitude, data?.longitude);
          navigate(`/clinic/${data?.slug}`);
        }}
      >
        <img
          src={
            data?.logo_image
              ? `${process.env.REACT_APP_BASE}${data?.logo_image}`
              : Pro
          }
          alt="pro"
          className="w-[70px] md:h-[100px] h-auto object-contain"
        />
        <div className="w-[calc(100%-)]">
          <h3 className="font-secondary text-primary font-medium text-[14px]">
            {data?.name}
          </h3>
          <div className="flex gap-4 items-center mt-2">
            <img src={location} className="w-[10px] h-auto" />
            <div className="font-primary text-lightgray font-normal text-[10px] ">
              {data?.address_line1}, {data?.address_line2},{" "}
              {data?.secretariats_data?.name}, {data?.district_data?.name},
              {data?.province_data?.name}
            </div>
          </div>
          {/* <div className="flex gap-4 items-center mt-2">
            <img src={Call} className="w-[10px] h-auto " />
            <div className="font-primary text-lightgray font-normal text-[10px] ">
              +94 77 123 4567
            </div>
          </div> */}
        </div>
      </div>
      <button
        className="w-full mt-5 bg-primary py-3 text-white text-[14px] font-semibold rounded-md"
        onClick={() => {
          navigate(`/clinic/${data?.slug}`);
        }}
      >
        Book an Appointment
      </button>
    </div>
  );
};

export default HospitalCard;
